export const validRedirect = (redirectUrl) => {
  if (!redirectUrl) return false;

  return /^(https?:\/\/([\w]*\.)?(storytel\.com|storytel\.dev|mofibo\.com)(\/.*)?$|\/)/i.test(
    redirectUrl
  );
};
